import {
  BarChart3,
  Route,
  Wand2,
  Database,
  FlaskConical,
  Users,
} from "lucide-react";

const FEATURES = [
  {
    icon: BarChart3,
    title: "Cost Analytics",
    copy: "Per-run token ledger across every agent and model. See exactly where spend concentrates and verify savings on each session.",
    testid: "platform-card-analytics",
  },
  {
    icon: Route,
    title: "Adaptive Model Routing",
    copy: "Simple turns go to cheap models, hard turns to frontier ones. Routing decisions are logged and explainable.",
    testid: "platform-card-routing",
  },
  {
    icon: Wand2,
    title: "Autopilot Fixes",
    copy: "Tests candidate fixes against your historical requests and opens pull requests with measured token deltas.",
    testid: "platform-card-autopilot",
  },
  {
    icon: Database,
    title: "Lossless Recovery",
    copy: "Compressed context stays recoverable. Agents pull original files back through native MCP the moment they need them.",
    testid: "platform-card-recovery",
  },
  {
    icon: FlaskConical,
    title: "Regression Evals",
    copy: "Turn real agent requests into test gates. Ship prompt or tool changes only when quality holds and cost drops.",
    testid: "platform-card-evals",
  },
  {
    icon: Users,
    title: "Team Controls",
    copy: "Shared dashboards, per-seat budgets, and spend alerts so a whole engineering org stays lean by default.",
    testid: "platform-card-teams",
  },
];

export const Platform = () => {
  return (
    <section
      data-testid="platform-section"
      className="max-w-6xl mx-auto px-6 py-24 border-b border-seam"
    >
      <div className="mb-12">
        <span className="text-xs font-semibold uppercase tracking-widest text-ember">
          Platform
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-white mt-1">
          Everything around the compression core
        </h2>
        <p className="text-sm text-smoke mt-3 max-w-xl leading-relaxed">
          The local proxy is free and open. Flintly Cloud adds the control
          plane for teams that run agents all day.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURES.map((f) => (
          <div
            key={f.title}
            data-testid={f.testid}
            className="rounded-xl border border-seam bg-coal p-6 hover:border-ember/50 transition-colors group"
          >
            <div className="w-10 h-10 rounded-lg bg-ember/10 border border-ember/25 flex items-center justify-center mb-4 group-hover:bg-ember/20 transition-colors">
              <f.icon className="w-5 h-5 text-ember" />
            </div>
            <h3 className="text-base font-semibold text-white mb-2">
              {f.title}
            </h3>
            <p className="text-xs text-smoke leading-relaxed">{f.copy}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
